import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'
import { gsap } from 'gsap'
import Interaction from 'three.interaction/src/interaction/Interaction.js'
import styles from './styles/styles.scss' 
import { Vector3 } from 'three'
import { slider } from './slider.js'
import { RoomEnvironment } from 'three/examples/jsm/environments/RoomEnvironment.js';

slider();

import LocomotiveScroll from 'locomotive-scroll';

const scrollerOverlay = new LocomotiveScroll({
    el: document.querySelector('[data-scroll-container]'),
    smooth: true,
    mobile: {
        breakpoint: 0, 
        smooth: true
    },
    tablet: {
        breakpoint: 0, 
        smooth: true
    }
});

new ResizeObserver(() => scrollerOverlay.update()).observe(document.querySelector("[data-scroll-container]"))

scrollerOverlay.on('scroll', (instance) => {
    animateNumbers();
});

window.onload = function() {
    initExperience(window.innerWidth, window.innerHeight)
};

window.onresize = function() {
    //initExperience(window.innerWidth, window.innerHeight)
};


function initExperience(width, height) {
    //console.log(width, height);
    if(width < 768 || width >= 530 && width <= 890 && height <= 500) {
        document.body.classList.add('loaded');
        window.setTimeout(() =>
            {
                scrollanimatethis($('.experience-mobile-inner'), 20000);
            }, 500)
        document.getElementById("experience-mobile-inner").addEventListener('touchstart', function(e) {
            $( ".experience-mobile-inner" ).stop();
        }, false);

        document.querySelectorAll('[data-overlay]').forEach(function (el) {
            el.addEventListener('click', function () {

                resetNumbers();

                var overlayId = el.getAttribute('data-overlay');

       
                // hide all divs with class  class="overlay-section"
                document.querySelectorAll('.overlay-section').forEach(function (el) {
                    el.classList.remove('overlay-section-active');
                    document.body.classList.remove('overlay-section-has-scroll');
                });

                document.body.classList.remove('fly-mode');
                
                // add class "overlay-section-active" to div with id = data-overlay
                document.querySelector('#' + overlayId).classList.add('overlay-section-active');

                // if this overlay is higher than the viewport, add class "overlay-section-has-scroll" to el
                if (document.querySelector('#' + overlayId).offsetHeight > window.innerHeight) {
                    document.body.classList.add('overlay-section-has-scroll');
                }

                // add class "overlay-active" to body
                document.body.classList.add('overlay-active');

                scrollerOverlay.update()

                // autoplay audio
                var audio = document.querySelectorAll('.overlay-section-active .audio.autoplay');
                audio.forEach(function(audio) {
                    audio.querySelector('audio').play();
                });

                animateNumbers();

                

            });
                
            
        });

        document.querySelector("#go-back").addEventListener('click', function() {

            document.body.classList.remove('overlay-active');
            document.body.classList.remove('overlay-section-has-scroll');

            // find all videos in .video, pause and reset them
            var videos = document.querySelectorAll('.video');
                videos.forEach(function(video) {
                    video.querySelector('video').controls = false;
                    video.querySelector('video').pause();
                    video.querySelector('video').currentTime = 0;
                    video.classList.remove('active');
                }
            );

            var audio = document.querySelectorAll('.audio');
                audio.forEach(function(audio) {
                    audio.querySelector('audio').pause();
                    audio.querySelector('audio').currentTime = 0;
                }
            );

            setTimeout(function () {
                scrollerOverlay.scrollTo('top', { duration: 0 });
                document.body.classList.add('fly-mode');
            }, 800);

            resetNumbers();

        
        });
        
    } else {
        experience();
    }
}

function scrollanimatethis(targetElement, speed) {
    var scrollWidth = $(targetElement).get(0).scrollWidth;
    var clientWidth = $(targetElement).get(0).clientWidth;
    $(targetElement).animate({ scrollLeft: scrollWidth - clientWidth },
    {
        duration: speed,
        complete: function () {
            targetElement.animate({ scrollLeft: 0 },
            {
                duration: speed,
                complete: function () {
                    scrollanimatethis(targetElement, speed);
                }
            });
        }
    });
};


function experience() {

    /**
     * Loaders
     */
    const loadingBarElement = document.querySelector('.loading-bar')

    let sceneReady = false
    let detailsOpen = false
    let zoomFinished = false


    const loadingManager = new THREE.LoadingManager(
        // Loaded
        () =>
        {
            // Wait a little
            window.setTimeout(() =>
            {
                document.body.classList.add('loaded')
            }, 500)

            window.setTimeout(() =>
            {
                sceneReady = true
            }, 2000)

            makeSceneInteractive()
        },

        // Progress
        (itemUrl, itemsLoaded, itemsTotal) =>
        {
            // Calculate the progress and update the loadingBarElement
            // const progressRatio = itemsLoaded / itemsTotal
            // loadingBarElement.style.transform = `scaleX(${progressRatio})`
        }
    )
    const gltfLoader = new GLTFLoader(loadingManager)
    const cubeTextureLoader = new THREE.CubeTextureLoader(loadingManager)

    /**
     * Base
     */
    // Debug
    const debugObject = {}

    // Canvas
    const canvas = document.querySelector('canvas.webgl')

    // Scene
    const scene = new THREE.Scene()


    /**
     * Update all materials
     */
    const updateAllMaterials = () =>
    {
        scene.traverse((child) =>
        {
            /*
            if(child instanceof THREE.Mesh && child.material instanceof THREE.MeshStandardMaterial)
            {
                child.material.envMap = environmentMap
                child.material.envMapIntensity = debugObject.envMapIntensity
                child.material.needsUpdate = false
                child.castShadow = false
                child.receiveShadow = false  
            } 
            */



            // if child names contains "Scheibe" set the objects.layer.enable to 1 to enable raycasting
            if (child.name.includes("Scheibe")) {
                //console.log(child.name)
                //child.layers.enable( 1 )
                raycastList.push(child);
            }

            if(child.name.includes("Track")) {
                //console.log(child.name)
                child.material = new THREE.MeshPhongMaterial( { side: THREE.BackSide } )
            }







        })

        //console.log(scene);
    }

    /**
     * Environment map
     */
    /* 
    const environmentMap = cubeTextureLoader.load([
        '/textures/environmentMaps/0/px.jpg',
        '/textures/environmentMaps/0/nx.jpg',
        '/textures/environmentMaps/0/py.jpg',
        '/textures/environmentMaps/0/ny.jpg',
        '/textures/environmentMaps/0/pz.jpg',
        '/textures/environmentMaps/0/nz.jpg'
    ])

    environmentMap.encoding = THREE.sRGBEncoding

    //scene.background = environmentMap
    scene.environment = environmentMap
    */
    debugObject.envMapIntensity = 1

    /**
     * Models
     */

    const dracoLoader = new DRACOLoader()
    dracoLoader.setDecoderPath( showroom_asset_path + 'draco/gltf/' )
    gltfLoader.setDRACOLoader( dracoLoader )

    let mixer = null

    const scalefactor = 0.05

    gltfLoader.load(
        showroom_asset_path + 'models/lokomotion-3d-experience_map14_baked_flat_low-textures.glb',
        (gltf) =>
        {
            gltf.scene.scale.set(scalefactor, scalefactor, scalefactor)
            gltf.scene.rotation.y = Math.PI * 0.1
            scene.add(gltf.scene)
            

            updateAllMaterials()

            mixer = new THREE.AnimationMixer(gltf.scene)
            mixer.clipAction(gltf.animations[0]).play()
            mixer.clipAction(gltf.animations[1]).play()
            mixer.clipAction(gltf.animations[2]).play()
            mixer.clipAction(gltf.animations[3]).play()
            mixer.clipAction(gltf.animations[4]).play()
            mixer.clipAction(gltf.animations[5]).play()
            mixer.clipAction(gltf.animations[6]).play()
            mixer.clipAction(gltf.animations[7]).play()
            mixer.clipAction(gltf.animations[8]).play()
            mixer.clipAction(gltf.animations[9]).play()
            mixer.clipAction(gltf.animations[10]).play()
            //action.play()



        }
    )




    gltfLoader.load(
        showroom_asset_path + 'models/essen.glb',
        (gltf) =>
        {
            // Apply the same scale factor as the main model
            gltf.scene.scale.set(scalefactor + 0.02, scalefactor + 0.02, scalefactor + 0.02)
            
            gltf.scene.position.set(-5.8, 0.95, -5.6)
            
            scene.add(gltf.scene)
            
            updateAllMaterials()
            
        }
    )



    /**
     * Points of interest
     */
    const raycaster = new THREE.Raycaster()
    //raycaster.layers.set( 1 ); 
    const raycastList = []

    var points = [
        {
            id: 'zentrale',
            position: new THREE.Vector3(-2, 1.4, 0.2),
            element: document.querySelectorAll("[data-overlay='zentrale']")[0],
            zoomtarget: { 
                x: -2,
                y: 1.25,
                z: 0.2,
                zoom: 1.5
            }
        },
        {
            id: 'azubi',
            position:new THREE.Vector3(-.8, 1.4, 0.7),
            element: document.querySelectorAll("[data-overlay='azubi']")[0],
            zoomtarget: { 
                x: -.9,
                y: 1.3,
                z: 0.3,
                zoom: 1.3
            }
        },
        {
            id: 'mor',
            position:new THREE.Vector3(-1.5, 1.1, 2),
            element: document.querySelectorAll("[data-overlay='mor']")[0],
            zoomtarget: { 
                x: -1.5,
                y: 1.2,
                z: 2,
                zoom: 1.3
            }
        },
        {
            id: 'swechat',
            position:new THREE.Vector3(7.8, 1, -3.5),
            element: document.querySelectorAll("[data-overlay='swechat']")[0],
            zoomtarget: { 
                x: 8,
                y: 1.24,
                z: -3.2,
                zoom: 1.2
            }
        },
        {
            id: 'brenner',
            position:new THREE.Vector3(2.2, 1.5, 4.7),
            element: document.querySelectorAll("[data-overlay='brenner']")[0],
            zoomtarget: { 
                x: 2.2,
                y: 1.5,
                z: 4.7,
                zoom: 1.3
            }
        },
        {
            id: 'umwelt',
            position:new THREE.Vector3(0.4, 1.7, 5.8),
            element: document.querySelectorAll("[data-overlay='umwelt']")[0],
            zoomtarget: { 
                x: 0.5,
                y: 1.7,
                z: 6.2,
                zoom: 3
            }
        },
        {
            id: 'muc-nord',
            position:new THREE.Vector3(-3.3, 1.2, -.45),
            element: document.querySelectorAll("[data-overlay='muc-nord']")[0],
            zoomtarget: { 
                x: -3.3,
                y: 1.2,
                z: -0.45,
                zoom: 1.3
            }
        },
        {
            id: 'terminal-riem',
            position:new THREE.Vector3(1, 1.2, 0),
            element: document.querySelectorAll("[data-overlay='terminal-riem']")[0],
            zoomtarget: { 
                x: 0.8,
                y: 1.2,
                z: -0.4,
                zoom: 1.3
            }
        },
        {
            id: 'streckennetz',
            position:new THREE.Vector3(2.8, 1, -1.6),
            element: document.querySelectorAll("[data-overlay='streckennetz']")[0],
            zoomtarget: { 
                x: 2.8,
                y: 1.3,
                z: -1.6,
                zoom: 1
            }
        },
        {
            id: 'zebra',
            position:new THREE.Vector3(-3.6, 1.2, 1.4),
            element: document.querySelectorAll("[data-overlay='zebra']")[0],
            zoomtarget: { 
                x: -3.6,
                y: 1.1,
                z: 1.4,
                zoom: 0.5
            }
        },
        {
            id: 'lokwerkstatt',
            position:new THREE.Vector3(2.7, 1.2, 1.2),
            element: document.querySelectorAll("[data-overlay='lokwerkstatt']")[0],
            zoomtarget: { 
                x: 1.9,
                y:  1.25,
                z: 1.2,
                zoom: 1.1
            }
        },
        {
            id: 'lok360',
            position:new THREE.Vector3(2.1, 1.2, 1),
            element: document.querySelectorAll("[data-overlay='lok360']")[0],
            zoomtarget: { 
                x: 1.7,
                y:  1.25,
                z: 1.3,
                zoom: 1.1
            }
        },
        {
            id: 'essen',
            position:new THREE.Vector3(-6.1, 1, -6),
            element: document.querySelectorAll("[data-overlay='essen']")[0],
            zoomtarget: { 
                x: -5.5,
                y:  1.05,
                z: -6.3,
                zoom: 1.2
            }
        }
    ]

    // remove points that have no element
    points = points.filter(function (point) {
        return point.element !== null && point.element !== undefined;
    });

    /**
     * Lights
     */

    const directionalLight = new THREE.DirectionalLight('#98C8EB', 5)
    /* directionalLight.castShadow = false
    directionalLight.shadow.camera.far = 15
    directionalLight.shadow.mapSize.set(1024, 1024)
    directionalLight.shadow.normalBias = 0.05 */
    directionalLight.position.set(-3, 3, - 2.25)
    scene.add(directionalLight)

    const ambientLight  =new THREE.AmbientLight('#ffffff', 1)
    scene.add(ambientLight)



    /**
     * Sizes
     */
    const sizes = {
        width: window.innerWidth,
        height: window.innerHeight
    }

    window.addEventListener('resize', () =>
    {
        // Update sizes
        sizes.width = window.innerWidth
        sizes.height = window.innerHeight

        // Update camera
        camera.aspect = sizes.width / sizes.height
        camera.updateProjectionMatrix()

        // Update renderer
        renderer.setSize(sizes.width, sizes.height)
        //renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
        renderer.setPixelRatio(1);
    })

    /**
     * Camera
     */
    // Base camera
    const camera = new THREE.PerspectiveCamera(60, sizes.width / sizes.height, 0.1, 100)
    camera.position.set(0, 3, 5)
    //camera.setViewOffset( sizes.width*3, sizes.height*3, 0, sizes.height * 2, sizes.width, sizes.height);
    scene.add(camera)



    // Controls
    const controls = new OrbitControls(camera, canvas)
    controls.enableDamping = true
    controls.dampingFactor = 0.05
    controls.screenSpacePanning = false
    controls.noZoom = true
    controls.enableZoom = false
    controls.mouseButtons = {
        LEFT: THREE.MOUSE.PAN,
    /* 	MIDDLE: THREE.MOUSE.DOLLY,
        RIGHT: THREE.MOUSE.ROTATE */
    }
    controls.touches = {
        ONE: THREE.TOUCH.PAN,
        /* TWO: THREE.TOUCH.DOLLY_PAN */
    }


    // limit control movement
    var minPan = new THREE.Vector3( -4, -5, -8 );
    var maxPan = new THREE.Vector3( 8.5, 7, 4.5 );
    var _v = new THREE.Vector3();
        
    controls.addEventListener("change", function() {
        userInteracted()
        _v.copy(controls.target);
        controls.target.clamp(minPan, maxPan);
        _v.sub(controls.target);
        camera.position.sub(_v);
    })

    // function that adds a class to the body when called and starts a counter that removes the class after 3 seconds. If it is called again the counter is reset.
    var userInteracted = function() {
        var body = document.querySelector('body');
        body.classList.add('user-interacted');
        clearTimeout(userInteracted.timer);
        userInteracted.timer = setTimeout(function() {
            body.classList.remove('user-interacted');
        }, 3000);
    };


    /**
     * Renderer
     */
    const renderer = new THREE.WebGLRenderer({
        canvas: canvas,
        antialias: true,
        alpha: true
    })
    renderer.physicallyCorrectLights = true
    renderer.outputEncoding = THREE.sRGBEncoding
    renderer.toneMapping = THREE.LinearEncoding
    renderer.toneMappingExposure = 0.5
    /* renderer.shadowMap.enabled = true
    renderer.shadowMap.type = THREE.PCFSoftShadowMap */
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(1)



    /**
     * Environment map
     */

    const pmremGenerator = new THREE.PMREMGenerator( renderer );
    scene.environment = pmremGenerator.fromScene( new RoomEnvironment(), 0.04 ).texture;



    /**
     * Interactivity
     */
    //const interaction = new Interaction(renderer, scene, camera);

    const makeSceneInteractive = () => {
        
        document.querySelectorAll('[data-overlay]').forEach(function (el) {
            el.addEventListener('click', function () {

                resetNumbers();

                var overlayId = el.getAttribute('data-overlay');

                // find id with value from overlayId in points array
                var point = points.find(point => point.id === overlayId);

                zoomView(point.zoomtarget.x, point.zoomtarget.y, point.zoomtarget.z, point.zoomtarget.zoom);

                //zoomView(zentrale.position.x, zentrale.position.y + 3, zentrale.position.z, 2);
                detailsOpen = true

                // hide all divs with class  class="overlay-section"
                document.querySelectorAll('.overlay-section').forEach(function (el) {
                    el.classList.remove('overlay-section-active');
                    document.body.classList.remove('overlay-section-has-scroll');
                });

                document.body.classList.remove('fly-mode');
                



                // add class "overlay-section-active" to div with id = data-overlay
                document.querySelector('#' + overlayId).classList.add('overlay-section-active');

                // if this overlay is higher than the viewport, add class "overlay-section-has-scroll" to el
                if (document.querySelector('#' + overlayId).offsetHeight > window.innerHeight) {
                    document.body.classList.add('overlay-section-has-scroll');
                }

                // add class "overlay-active" to body
                document.body.classList.add('overlay-active');

                scrollerOverlay.update()

                // autoplay audio
                var audio = document.querySelectorAll('.overlay-section-active .audio.autoplay');
                audio.forEach(function(audio) {
                    audio.querySelector('audio').play();
                });

                animateNumbers();

                

            });
                
            
        });


        document.querySelector("#go-back").addEventListener('click', function() {

            zoomView(0, 3, 5, 0, true);
            detailsOpen = false
            document.body.classList.remove('overlay-active');
            document.body.classList.remove('overlay-section-has-scroll');

            // find all videos in .video, pause and reset them
            var videos = document.querySelectorAll('.video');
                videos.forEach(function(video) {
                    video.querySelector('video').controls = false;
                    video.querySelector('video').pause();
                    video.querySelector('video').currentTime = 0;
                    video.classList.remove('active');
                }
            );

            var audio = document.querySelectorAll('.audio');
                audio.forEach(function(audio) {
                    audio.querySelector('audio').pause();
                    audio.querySelector('audio').currentTime = 0;
                }
            );

            setTimeout(function () {
                scrollerOverlay.scrollTo('top', { duration: 0 });
                document.body.classList.add('fly-mode');
            }, 800);

            resetNumbers();

        
        });


        document.querySelectorAll('[data-iframe]').forEach(function (el) {
            el.addEventListener('click', function (e) {

                e.preventDefault();

                document.body.classList.add('iframe-active');

                var iframeId = el.getAttribute('data-iframe');
                document.querySelector('#iframe-360 iframe').src = iframeId;

            });
        });

        document.querySelector("#close-iframe").addEventListener('click', function() {
            document.body.classList.remove('iframe-active');
            document.querySelector('#iframe-360 iframe').src = '#';
        });
    }

    let temp_camera_position = new THREE.Vector3();
    let temp_control_target = new THREE.Vector3();

    const zoomView = (x, y, z, zoomOutFactor = 0, reset = false) => {
        zoomFinished = false;
        
        let x_target, y_target, z_target, x_camera, y_camera, z_camera;
        let offset = 2;
        if(!reset) {
            x_target = x + offset
            y_target = y 
            z_target = z
            x_camera = x_target - 0.6  - offset
            y_camera = y_target
            z_camera = z_target + zoomOutFactor
            temp_camera_position.x = camera.position.x;
            temp_camera_position.y = camera.position.y;
            temp_camera_position.z = camera.position.z;
            temp_control_target.x = controls.target.x;
            temp_control_target.y = controls.target.y;
            temp_control_target.z = controls.target.z;
        } else {
            x_target = temp_control_target.x
            y_target = temp_control_target.y
            z_target = temp_control_target.z
            x_camera = temp_camera_position.x
            y_camera = temp_camera_position.y
            z_camera = temp_camera_position.z
        }

        let tl = gsap
            .timeline({ defaults: { duration: 1.5, ease: "expo.out"} })
            .to(controls.target, new Vector3(x_target, y_target, z_target))
            .to(camera.position, new Vector3(x_camera, y_camera, z_camera ), 0)
            .call(() => {
                zoomFinished = true;
                if(!reset) {
                    // loop camera movement with gsap
                    let cameraMovement = gsap
                        .to(camera.position, { 
                            x: x_camera - 0.2, 
                            y: y_camera + 0.05, 
                            z: z_camera, 
                            ease: "sine.inOut", 
                            repeat: -1, 
                            yoyo: true, 
                            duration: 8 
                        } )
                } else {
                    gsap.killTweensOf(camera.position);
                }
            })
            
            
    };





    /**
     * Animate
     */


    var clock = new THREE.Clock();
    let previousTime = 0

    const tick = () =>
    {  

        const elapsedTime = clock.getElapsedTime()
        const deltaTime = elapsedTime - previousTime
        previousTime = elapsedTime

        // Update controls
        controls.update()

        // do animation
        if(mixer)
        {
            mixer.update(deltaTime)
        }

        
        // Update points only when the scene is ready
        if(sceneReady)
        {
            // Go through each point
            for(const point of points)
            {
                // Get 2D screen position
                const screenPosition = point.position.clone()
                screenPosition.project(camera)
        
                // Set the raycaster
                raycaster.setFromCamera(screenPosition, camera)
                const intersects = raycaster.intersectObjects(raycastList, true)

                // No intersect found
                if(intersects.length === 0)
                {
                
                    point.element.classList.add('visible')
                    
                    /*
                    if(pointDistance > 7) {
                        point.element.classList.remove('visible')
                    } else {
                        // Show
                        point.element.classList.add('visible')
                    }
                    */

                }

                // Intersect found
                else
                {
                    // Get the distance of the intersection and the distance of the point
                    const intersectionDistance = intersects[0].distance
                    
                    const pointDistance = point.position.distanceTo(camera.position)
                    
        
                    // Intersection is close than the point
                    if(intersectionDistance < pointDistance)
                    {
                        // Hide
                        point.element.classList.remove('visible')
                    }
                    // Intersection is further than the point
                    else
                    {
                        // Show
                        point.element.classList.add('visible')
                    }
                }
        
                const translateX = screenPosition.x * sizes.width * 0.5
                const translateY = - screenPosition.y * sizes.height * 0.5
                point.element.style.transform = `translateX(${translateX}px) translateY(${translateY}px)`
            }
        }
        

        // Render
        renderer.render(scene, camera)

        // Call tick again on the next frame
        window.requestAnimationFrame(tick)
    }

    tick()

}


/*
 video player
*/
// listen for click of the .video::after. If clicked play the video in the same .video container
document.querySelectorAll('.video').forEach(item => {
    item.addEventListener('click', event => {
        // add controls to video
        item.querySelector('video').controls = true;
        item.classList.add('active');
        item.querySelector('video').play();
    })
})


/*
    animate numbers
*/
function animateNumbers() {

    const animatedNumbers = document.querySelectorAll('.overlay-section-active .animated-number.is-inview:not(.animated)');
    
    animatedNumbers.forEach(function(number) {

        number.classList.add('animated');

        const value = number.getAttribute('data-number');
        
        let counter = 0;
        var duration = 200;
    
        const timer = setInterval(function() {
            counter = counter + value / duration;
            number.innerHTML = Math.ceil(counter).toLocaleString('de-DE');
            if (!document.body.classList.contains('overlay-active')) {
                clearInterval(timer);
            }
            if (counter >= value) {
                clearInterval(timer);
                number.innerHTML = Math.ceil(value).toLocaleString('de-DE');
            }
        }, 20);
    });
}

function resetNumbers() {
    const animatedNumbers = document.querySelectorAll('.animated-number.animated');
    animatedNumbers.forEach(function(number) {
        number.classList.remove('animated');
        number.classList.remove('is-inview');
        number.innerHTML = 0;
    });
}